<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/goodslist' }">商品管理</el-breadcrumb-item>
            <el-breadcrumb-item>添加商品</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区-->
        <el-card>
            <el-form :model="addForm" :rules="addFormRules" ref="addFormRef"  label-width="100px" style="width:90%;margin:10px auto">
                    <el-form-item label="所属类型" prop="goods_class">
                        <el-cascader :options="classlist" @change="handleChange"></el-cascader>
                    </el-form-item>
                    <el-form-item label="商品名称" prop="goods_name">
                        <el-input v-model="addForm.goods_name"></el-input>
                    </el-form-item>
                    <el-form-item label="商品图片" prop="goods_pic">
                        <el-upload
                            ref="imgBroadcastUpload"
                            :limit="limitNum"
                            :auto-upload="true"
                            :file-list="fileList"
                            :on-success="addPic"
                            :on-change="changePic"
                            list-type="picture-card"
                            accept="image/jpg"
                            :action="uploadAction">
                                <i class="el-icon-plus"></i>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="商品简介" prop="goods_info">
                        <!--富文本编辑器-->
                        <myeditor @editorContent="change($event)"></myeditor>
                    </el-form-item>
                    <el-form-item label="商品参数" prop="goods_param">
                        <!--富文本编辑器-->
                        <myeditor @editorContent="change1($event)"></myeditor>
                    </el-form-item>
                    <el-form-item v-if="isWebSite" label="租售模式">
                        <el-tag type="success">仅出售（网站端固定）</el-tag>
                    </el-form-item>
                    <el-form-item v-else label="租售模式" prop="goods_sign">
                        <el-radio-group v-model="addForm.goods_sign" size="medium">
                            <el-radio label="1" border>仅出售</el-radio>
                            <el-radio label="2" border>仅租赁</el-radio>
                            <el-radio label="3" border>既出售又租赁</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="销售价格" prop="goods_price">
                        <el-input v-model="addForm.goods_price" style="width:300px"></el-input> 元
                    </el-form-item>
                    <el-form-item label="月租金" prop="goods_month" v-if="addForm.goods_sign != '1'">
                        <el-input v-model="addForm.goods_month" style="width:300px" @blur="getDeposit"></el-input> 元
                    </el-form-item>
                    <el-form-item label="押金" prop="goods_deposit" v-if="addForm.goods_sign != '1'">
                        <el-input v-model="addForm.goods_deposit" style="width:300px"></el-input> 元
                    </el-form-item>
                    <el-form-item label="商品佣金" prop="goods_commission">
                        <el-input v-model="addForm.goods_commission" style="width:300px"></el-input> 元
                    </el-form-item>
                    <el-form-item label="是否显示">
                        <el-switch v-model="addForm.goods_index" active-value="True" inactive-value="False"></el-switch>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="addDialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="addGoods">确 定</el-button>
                    </el-form-item>
                </el-form>
        </el-card>
    </div>
</template>
<script>
export default {
    computed: {
        isWebSite() {
            return window.sessionStorage.getItem('site') === 'web'
        },
        uploadAction() {
            const site = window.sessionStorage.getItem('site') || 'miniapp'
            return this.GLOBAL.imgURL + 'upload/?site=' + encodeURIComponent(site)
        }
    },
    data(){
        return {
            imgURL:this.GLOBAL.imgURL,
            limitNum: 3,
            fileList:[],
            classlist:[],
            //添加表单数据
            addForm:{
                 goods_class:'',
                 goods_name:'',
                 goods_pic:[],
                 goods_info:'',
                 goods_param:'',
                 goods_price:'',
                 goods_month:'',
                 goods_deposit:'',
                 goods_proportion:'',
                 goods_sign:'1',
                 goods_index:'False',
            },
            //添加表单验证规则
            addFormRules:{
                goods_class:[
                    { required: true, message: '请选择商品类型', trigger: 'blur' }
                ],
                goods_name:[
                    { required: true, message: '请输入商品名称', trigger: 'blur' }
                ],
                goods_info:[
                    { required: true, message: '请输入商品详情', trigger: 'blur' }
                ],
                goods_price:[
                    { required: true, message: '请输入商品价格', trigger: 'blur' }
                ],
                goods_month:[
                    { required: true, message: '请输入商品月租金', trigger: 'blur' }
                ],
                goods_deposit:[
                    { required: true, message: '请输入商品押金', trigger: 'blur' }
                ],
                goods_commission:[
                     { required: true, message: '请输入商品佣金', trigger: 'blur' }
                ]
            },
        }
    },
    created () {
        if (window.sessionStorage.getItem('site') === 'web') {
            this.addForm.goods_sign = '1'
            this.addFormRules.goods_month = []
            this.addFormRules.goods_deposit = []
        }
        this.getClass()
    },
    methods:{
        async getClass(){
            const { data: res } = await this.$http.get('goodsclass/')
            this.classlist = res.data
        },
        addPic(response, file, fileList){
            const name = response && response.picname ? response.picname : (file && file.response && file.response.picname)
            if (name) {
                this.addForm.goods_pic.push(name)
            }
        },
        change(data) {
            this.addForm.goods_info = data;
        },
        change1(data) {
            this.addForm.goods_param = data;
        },
        async addGoods(){
            console.log(this.addForm)
            //   console.log(this.fileList)
              this.$refs.addFormRef.validate( async valid=>{
                if (!valid) return
                const payload = { ...this.addForm }
                if (this.isWebSite) {
                    payload.goods_sign = '1'
                    payload.goods_month = ''
                    payload.goods_deposit = ''
                }
                const { data:res } = await this.$http.post('goodsadd/', payload)
                if(res.status===0)
                {
                    this.$message.success('添加商品成功！')
                    this.$router.push({path: '/goodslist'})
                }
              })
       },
       handleChange(value) {
        this.addForm.goods_class = value.join(', ')
        // console.log(this.addForm.goods_class)
      },
      changePic(file, fileList){
        // console.log(this.fileList);
        // this.fileList = fileList.slice(-3);
        // console.log(this.fileList);
      },
      getDeposit(){
        this.addForm.goods_deposit = this.addForm.goods_month * 3
        console.log(this.addForm.goods_deposit);
      }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
        
    }
    .el-breadcrumb{
        width: 100%;
    }
    
</style>